module.exports = __webpack_public_path__ + "ChicagoInABoxAfter.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ChicagoInABoxAfter.jpg
// module id = 841
// module chunks = 0